import { cosignErrorCode } from '@constants'
import { type SnackbarVariantsProps } from '@pets-ui/Snackbar/SnackbarVariants'
import { useSnackbar } from '@pets-ui/Snackbar/useSnackbar'
import { type AxiosError } from 'axios'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { type SendOtpErrorResponse } from '../types/apiErrorResponse'

export function useOtpSendErrorHandler(onResendLimitReached: (detail: SendOtpErrorResponse['detail']) => void) {
  const { t } = useTranslation()
  const { openSnackbar } = useSnackbar<SnackbarVariantsProps>()

  return useCallback((error: unknown) => {
    const { response } = error as AxiosError<SendOtpErrorResponse>
    if (response?.data?.code === cosignErrorCode.OTP_RESEND_LIMIT_REACHED || response?.data?.code === cosignErrorCode.OTP_RESEND_LIMIT_REACHED_2) {
      onResendLimitReached(response.data.detail)
    }
    else if (response?.data?.code === cosignErrorCode.RECAPTCHA_VALIDATION_FAILED) {
      openSnackbar({ message: t('error.otpRecaptchaFailed'), severity: 'error' })
    }
    else if (response?.data?.code === cosignErrorCode.EMAIL_PROVIDER_NOT_SUPPORTED) {
      openSnackbar({ message: t('error.otpEmailProviderNotSupported'), severity: 'error' })
    }
    else if (response?.data?.code === cosignErrorCode.EMAIL_DOMAIN_VERIFICATION_UNAVAILABLE) {
      openSnackbar({ message: t('error.otpEmailDomainVerificationUnavailable'), severity: 'error' })
    }
    else {
      openSnackbar({ message: t('error.otpSendFailed'), severity: 'error' })
    }
  }, [onResendLimitReached, openSnackbar, t])
}
